/* TRVL redesign — behaviour for trvl-* sections. No dependencies. */
(function () {
  'use strict';

  var cfg = window.TRVL || {};
  var money = function (cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100);
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return v;
    });
  };

  /* ---------- Delivery estimate with dispatch cut-off ---------- */
  function deliveryInfo() {
    var cutoff = String(cfg.cutoff || '16:30').split(':');
    var cutMins = (+cutoff[0] || 0) * 60 + (+cutoff[1] || 0);
    var now = new Date();
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now);
    var h = +parts.find(function (p) { return p.type === 'hour'; }).value;
    var m = +parts.find(function (p) { return p.type === 'minute'; }).value;
    var left = cutMins - (h * 60 + m);
    var shift = left > 0 ? 0 : 1;
    var addDays = function (n) {
      var d = new Date(now);
      var added = 0;
      var total = n + shift;
      if (cfg.weekends !== false) { d.setDate(d.getDate() + total); return d; }
      while (added < total) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      return d;
    };
    var from = addDays(cfg.minDays || 2), to = addDays(cfg.maxDays || 3);
    return {
      lead: left > 0 ? 'Order within ' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm' : 'Order now',
      from: from.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric' }),
      to: to.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })
    };
  }
  function renderDelivery() {
    var d = deliveryInfo();
    document.querySelectorAll('[data-trvl-delivery]').forEach(function (el) {
      var lead = el.querySelector('[data-lead]'), range = el.querySelector('[data-range]');
      if (lead) lead.textContent = d.lead;
      if (range) range.textContent = d.from + ' – ' + d.to;
    });
  }

  /* ---------- Add to cart (opens Motion's cart drawer) ---------- */
  function addItems(items, button) {
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (document.getElementById('CartDrawer')) {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          window.location.href = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
        }
      })
      .catch(function (err) {
        alert((err && (err.description || err.message)) || 'Sorry, that could not be added to your cart.');
      })
      .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
  }

  /* ---------- Product section ---------- */
  function initProduct(root) {
    if (root.dataset.trvlReady) return; root.dataset.trvlReady = '1';
    var dataEl = root.querySelector('[data-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var form = root.querySelector('[data-trvl-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('[data-qty]');
    var threshold = (cfg.giftThreshold || 0) * 100;
    var current = product && product.variants.find(function (v) { return String(v.id) === (idInput && idInput.value); }) || (product && product.variants[0]);

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function addonTotal() {
      var t = 0;
      root.querySelectorAll('[data-addon]:checked').forEach(function (c) { t += +c.dataset.price; });
      return t;
    }
    function updateGift(el, total) {
      if (!el || !threshold) return;
      var left = threshold - total;
      var msg = el.querySelector('[data-gift-msg]'), fill = el.querySelector('[data-gift-fill]');
      if (msg) msg.innerHTML = left > 0 ? el.dataset.textMore.replace('[amount]', '<strong>' + money(left) + '</strong>') : el.dataset.textDone;
      if (fill) fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    }
    function refresh() {
      if (!current) return;
      var base = current.price * qty();
      updateGift(root.querySelector('[data-gift]'), base);
      root.querySelectorAll('[data-price-now]').forEach(function (e) { e.textContent = money(current.price); });
      root.querySelectorAll('[data-price-was]').forEach(function (e) {
        var on = current.compare_at_price > current.price; e.hidden = !on; e.textContent = on ? money(current.compare_at_price) : '';
      });
      root.querySelectorAll('[data-price-save]').forEach(function (e) {
        var on = current.compare_at_price > current.price; e.hidden = !on;
        if (on) e.textContent = e.dataset.template.replace('[amount]', money(current.compare_at_price - current.price));
      });
      root.querySelectorAll('[data-atc]').forEach(function (b) {
        b.disabled = !current.available;
        var label = b.querySelector('[data-atc-label]'); if (label) label.textContent = current.available ? b.dataset.add : b.dataset.soldout;
      });
      var ftot = root.querySelector('[data-addons-total]');
      var n = root.querySelectorAll('[data-addon]:checked').length;
      if (ftot) ftot.textContent = money(current.price + addonTotal());
      var fcount = root.querySelector('[data-addons-count]'); if (fcount) fcount.textContent = n;
      var fbtn = root.querySelector('[data-addons-btn-count]'); if (fbtn) fbtn.textContent = n + 1;
      var fgift = root.querySelector('[data-addons-gift]');
      if (fgift && threshold) fgift.hidden = current.price + addonTotal() < threshold;
    }

    // Variant options
    root.querySelectorAll('[data-option]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var chosen = [];
        root.querySelectorAll('[data-option-group]').forEach(function (g) {
          var c = g.querySelector('input:checked'); chosen.push(c ? c.value : null);
        });
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        current = v; idInput.value = v.id;
        if (v.featured_media) {
          var slide = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        refresh();
      });
    });

    // Quantity
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() + (+b.dataset.qtyStep)); refresh(); });
    });
    if (qtyInput) qtyInput.addEventListener('change', refresh);
    root.querySelectorAll('[data-addon]').forEach(function (c) { c.addEventListener('change', refresh); });

    // Main add to cart: just this product
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      addItems([{ id: +idInput.value, quantity: qty() }], form.querySelector('[data-atc]'));
    });
    // Add-ons button: this product + ticked add-ons
    var addonsBtn = root.querySelector('[data-addons-submit]');
    if (addonsBtn) addonsBtn.addEventListener('click', function () {
      var items = [{ id: +idInput.value, quantity: qty() }];
      root.querySelectorAll('[data-addon]:checked').forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
      addItems(items, addonsBtn);
    });
    // Sticky bar mirrors the main button
    var sticky = root.querySelector('[data-sticky]');
    var mainBtn = form && form.querySelector('[data-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(mainBtn);
      sticky.querySelector('[data-sticky-atc]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
    // Mobile gallery dots
    var track = root.querySelector('[data-gallery-track]'), dots = root.querySelectorAll('[data-gallery-dot]');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
    }
    refresh();
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    if (root.dataset.trvlReady) return; root.dataset.trvlReady = '1';
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
    var overlay = root.querySelector('[data-hs-overlay]');
    if (!overlay || !dots.length) return;
    var idx = -1;
    function show(i) {
      idx = (i + dots.length) % dots.length;
      var d = dots[idx];
      dots.forEach(function (x, k) { x.setAttribute('aria-expanded', k === idx ? 'true' : 'false'); });
      overlay.querySelector('[data-hs-title]').textContent = d.dataset.title;
      overlay.querySelector('[data-hs-text]').textContent = d.dataset.text;
      overlay.querySelector('[data-hs-count]').textContent = (idx + 1) + ' / ' + dots.length;
      var img = overlay.querySelector('[data-hs-img]');
      if (d.dataset.img) { img.src = d.dataset.img; img.alt = d.dataset.title; img.hidden = false; } else { img.hidden = true; }
      overlay.classList.add('is-open');
      overlay.querySelector('[data-hs-close]').focus();
    }
    function hide() { overlay.classList.remove('is-open'); dots.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); if (dots[idx]) dots[idx].focus(); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    overlay.querySelector('[data-hs-close]').addEventListener('click', hide);
    overlay.querySelector('[data-hs-next]').addEventListener('click', function () { show(idx + 1); });
    overlay.querySelector('[data-hs-prev]').addEventListener('click', function () { show(idx - 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) hide(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-trvl-bundle]').forEach(function (b) {
      if (b.dataset.trvlReady) return; b.dataset.trvlReady = '1';
      b.addEventListener('click', function () { addItems(JSON.parse(b.dataset.trvlBundle), b); });
    });
    (scope || document).querySelectorAll('[data-trvl-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-trvl-hotspots]').forEach(initHotspots);
    renderDelivery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  setInterval(renderDelivery, 60000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
